import { Modal } from '@phoenix/design-system/frontend/ui/modal/modal';
import { Spinner } from '@phoenix/design-system/frontend/ui/spinner/spinner';
import { FC, useEffect } from 'react';
import { useLoadingOverlayBlocker } from './loading-overlay.context';

export const LoadingOverlayBlocker: FC = () => {
  const { loadingOverlayVisible } = useLoadingOverlayBlocker();

  useEffect(() => {
    const ignore = (event: Event) => {
      if (loadingOverlayVisible) {
        event.preventDefault();
      }
    };
    document.addEventListener('keyup', ignore);
    document.addEventListener('keydown', ignore);

    return () => {
      document.removeEventListener('keyup', ignore);
      document.removeEventListener('keydown', ignore);
    };
  }, [loadingOverlayVisible]);

  return (
    <Modal
      dialogIsOpen={loadingOverlayVisible}
      showCloseButton={false}
      contentClassName="bg-transparent"
      customSizeClassName="flex h-[100vh] items-center justify-center"
    >
      <Spinner />
    </Modal>
  );
};
